import { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import CountUp from 'react-countup';

//MUI
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

//Our Imports
import useInView from '../../../hooks/useInView';
import { useLenis } from '../../../ScrollLenisProvider';
import { imageExist } from '../../../assets/js/init';

const Counter = ({ viewOnce = true, scrollToSection, currentNav, setNavTrigger }) => {

	//InView Hook
	const [sectionRef, inView] = useInView();
	const lenis = useLenis();

	const theme    = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md')); 

	//State
	const [counterOnView, setCounterOnView] = useState(false);
	const [triggerPoint, setTriggerPoint] = useState(0);
	const [isNav, setIsNav] = useState(false);
	const [isFixed, setIsFixed] = useState(false);
	// const [highlightNav, setHighlightNav] = useState('');

	//Ref
	const NavRef = useRef(null);

	//Effect
	useEffect(() => { //Get Count is in view
		if (inView) {
			setCounterOnView(true);
		} else {
			setCounterOnView(false);
		}
	}, [inView]);

	// useEffect(() => {
	// 	setHighlightNav(currentNav);
	// }, [currentNav]);

	useEffect(() => { //Get Box Reach Top
		if (!NavRef.current) return;

		const rect = NavRef.current.getBoundingClientRect();
		const scrollTop = window.scrollY || document.documentElement.scrollTop;

		setTriggerPoint(rect.top + scrollTop);
	}, []);

	useEffect(() => {
		if (!lenis || isMobile) return;

		const handleScroll = ({ scroll }) => {
			// setHighlightNav(false);
			setNavTrigger('');
			if (scroll >= triggerPoint - 10) {
				setIsFixed(true);
			} else {
				setIsFixed(false);
			}

			if (scroll >= triggerPoint + 70) {
				setIsNav(true);
			} else {
				setIsNav(false);
			}
		};

		lenis.on('scroll', handleScroll);

		return () => {
			lenis.off('scroll', handleScroll);
		};
	}, [lenis, triggerPoint, isMobile, setNavTrigger]);

	//Animation
	const counterContainer = {
		hidden: {
			opacity: 0,
			y: 100
		},
		visible: {
			opacity: 1,
			y: 0,
			transition: {
				duration: 0.5,
				ease: [0.22, 1, 0.36, 1] // <-- smooth premium easing (important)
			}
		}
	};
		
	//Count Data
	const countData = [
		{ title: 'Wide range of financial calculators', count: 70, suffix: '+' },
		{ title: 'Organized categories', count: 15, suffix: '+' },
		{ title: 'Simple & User-Friendly Experience', count: 100, suffix: '%' }
	];

	//Header Menu List
	const menuList = [
		{
			menu: 'Demo',
			link: '#demo'
		},
		{
			menu: 'About',
			link: '#about'
		},
		{
			menu: 'Contact',
			link: '#contact'
		}
	];

	const handleScrollTop = () => {
		if (!lenis) return;
		lenis.scrollTo(0, { immediate: true });
	};

	return(
		<Container className='containerFull' ref={sectionRef}>
			<Box ref={NavRef}>
				<motion.div
					variants={counterContainer}
					initial='hidden'
					whileInView='visible'
					viewport={{ once: viewOnce, margin: '-80px' }}
				>
					<Box sx={{ height: { md: '220px', xs: 'max-content' }, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
						<Grid container spacing={4} justifyContent='space-between' alignItems='center' p={isNav && !isMobile ? '0px 10px' : '0px 32px'} className={`${isNav && !isMobile && 'navCounter'} ${isFixed && !isMobile && 'fixedCounter'} counterContainer`}>
							{isNav && !isMobile ?
								<Grid size={12}>
									<Stack direction='row' justifyContent='space-between' alignItems='center'>
										<Box sx={{ height: '20px', width: '20px' }} onClick={handleScrollTop} className='cursorPointer'>
											{imageExist({
												required : '/logo',
												url      : '/logo.svg',
												alt      : 'logo',
												height   : '100%',
												style: { marginLeft: '10px' }
											})}
										</Box>
										{menuList.map((list, i)=>(
											<Stack direction='row' alignItems='center' key={i}>
												{currentNav === list.link &&
													<Box sx={{ height: '10px', width: '10px', bgcolor: '#5B31A1', borderRadius: '50%', marginRight: '-10px' }}/>
												}
												<Typography color={currentNav === list.link ? 'primary' : '#262727'} key={i} className='font16 fontBolder cursorPointer navOption' onClick={(e) => scrollToSection(e, list.link)}>{list.menu}</Typography>
											</Stack>
										))}
										<Typography color='#262727' className='font16 fontBolder cursorPointer navOption'>Get App</Typography>
									</Stack>
								</Grid>
								:
								countData.map((list, index) => (
									<Grid key={index} size={{ md: 3.5, xs: 12 }} sx={{ position: 'relative' }}>
										<Box className='borderReducer'></Box>
										<Box sx={{ borderBottom: '1px solid #754FBA', overflow: 'hidden' }} className='mb10'>
											<Box className={`${counterOnView ? 'countDataView' : 'countData'}`} sx={{ height: '51px' }}>
												<CountUp start={0} end={list.count} duration={8} suffix={list.suffix} enableScrollSpy>
													{({ countUpRef }) => (<span className='font50 primaryCl fontBolder' ref={countUpRef} />)}
												</CountUp>
											</Box>
										</Box>
										<Typography fontWeight={500} className='font18' sx={{ whiteSpace: 'nowrap' }}>{list.title}</Typography>
									</Grid>
								))
							}
						</Grid>
					</Box>
				</motion.div>
			</Box>
		</Container>
	);
};

export default Counter;
